import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import utils from 'utils';
import cn from 'classnames';
import { PROFILE } from 'constants';
import MyTrips from 'components/MyTrips';
import ProfileAccount from 'components/ProfileAccount';
import Receipt from 'components/Receipt';
import { withRouter } from 'utils/hoc';

const { PROFILE_PATHS_CONFIG } = PROFILE;

const ProfileSPA = (router) => {
  const handleRouteUpdate = () => {
    if (!window.pageXOffset) {
      utils.dom.autoPageTop();
    }

    // Dispatch the analytics ready event to indicate a "new page load" (since this is a SPA)
    utils.analytics.init(utils.config.getPageInfo());
  };

  const className = cn('profile', { 'theme--dark-blue': !PROFILE_PATHS_CONFIG.myTrips });

  const pathname = router?.location?.pathname;

  return (
    <section className={className}>
      <utils.OnUpdateWrapper pathname={pathname} onUpdate={handleRouteUpdate}>
        <Routes>
          <Route path={PROFILE_PATHS_CONFIG.myProfile[0]} exact element={<ProfileAccount />} />
          <Route path={PROFILE_PATHS_CONFIG.myTrips[0]} exact element={<MyTrips />} />
          <Route path={PROFILE_PATHS_CONFIG.receipt[0]} exact element={<Receipt />} />
          <Route path='/' element={<Navigate to={PROFILE_PATHS_CONFIG.myProfile[0]} />} />
        </Routes>
      </utils.OnUpdateWrapper>
    </section>
  );
};

export default withRouter(ProfileSPA);
